export const state = {
    active_workspaces: {},
    active_quick_searches: {},
    active_tab: 0,
};
